import { useTranslation } from "react-i18next";
import GameCard from "./GameCard";
import { DollarSign, Brain, Map } from "lucide-react";

type GameCardGridProps = {
  className?: string;
};

const GameCardGrid = ({ className = "" }: GameCardGridProps) => {
  const { t } = useTranslation();

  // Dữ liệu mẫu cho các game card
  const games = [
    {
      id: 1,
      title: "Bánh xe Pháp",
      description: "Quay bánh xe và trả lời câu hỏi về các khái niệm Phật học cơ bản.",
      type: "Tương tác",
      link: "/quiz/dharma-wheel",
      icon: (
        <span className="text-4xl">☸</span>
      ),
    },
    {
      id: 2,
      title: "Tứ Vô Lượng Tâm",
      description: "Trò chơi ghi nhớ liên kết các khái niệm Từ, Bi, Hỷ, Xả với ý nghĩa của chúng.",
      type: "Trí nhớ",
      link: "/quiz/brahmavihara",
      icon: (
        <div className="text-amber-600 text-2xl font-semibold">慈悲</div>
      ),
    },
    {
      id: 3,
      title: "Hành trình Bát Chánh Đạo",
      description: "Đưa ra lựa chọn đúng đắn để hoàn thành hành trình trên Bát Chánh Đạo.",
      type: "Phiêu lưu",
      link: "/quiz/noble-path",
      icon: (
        <Map className="h-10 w-10 text-amber-600" />
      ),
    },
  ];

  return (
    <div className={`${className}`}>
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-amber-800 mb-4">Học thông qua trải nghiệm</h2>
        <p className="text-lg text-gray-700 max-w-3xl mx-auto">
          Tìm hiểu giáo lý Phật giáo qua bộ sưu tập các trò chơi tương tác được thiết kế để đào sâu hiểu biết của bạn.
        </p>
      </div>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {games.map((game) => (
          <GameCard
            key={game.id}
            id={game.id}
            title={game.title}
            description={game.description}
            type={game.type}
            link={game.link}
            icon={game.icon}
          />
        ))}
      </div>
    </div>
  );
};

export default GameCardGrid; 